<template>
    <el-container>
        <el-header height="88px">
            <HeaderNav :curHash="'about'" />
        </el-header>
        <el-main :style="`height:${contentHeight}; flex-grow:1; padding: 0`">

        </el-main>
        <el-footer height="54px">
            <Footer />
        </el-footer>
    </el-container>
</template>

<script>
import HeaderNav from '../components/header.vue'
import Footer from '../components/footer.vue'
export default {
  name: 'About',
  components: { HeaderNav, Footer },
  data () {
    return {
      contentHeight: 0
    }
  },
  methods: {
  },
  mounted () {
      this.$nextTick(() => {
          this.contentHeight = document.documentElement.clientHeight - 54 - 88 + 'px'
      })
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
</style>



// WEBPACK FOOTER //
// src/pages/about.vue